import type { JobStep } from '../cgOrders/jobStages';

/**
 * The nine steps, on one line, without scrolling.
 *
 * Both sides render this from the same array — the shared model in jobStages
 * decides which step a job is on, and only the WORD for whose turn it is
 * differs. That is what stops the board and the portal describing one job
 * differently.
 *
 * `viewer` picks that word. A factory reads "your move"; TAP reads "with the
 * supplier". Neither is baked into the model, because the moment one view says
 * "you" about a step the other also says "you" about, the two screens are
 * arguing.
 */
export function JobStageBar({ steps, viewer }: { steps: JobStep[]; viewer: 'supplier' | 'tap' }) {
  return (
    <ol className="job-stage-bar" aria-label="Job progress">
      {steps.map((step) => (
        <li key={step.key} className={`job-stage job-stage--${step.state}`}>
          <span className="job-stage-dot" aria-hidden="true" />
          <span className="job-stage-label">{step.label}</span>
          {step.state === 'current' && step.turn !== null ? (
            <span className="job-stage-turn">{turnWord(step.turn, viewer)}</span>
          ) : null}
        </li>
      ))}
    </ol>
  );
}

function turnWord(turn: 'supplier' | 'tap', viewer: 'supplier' | 'tap'): string {
  if (turn === viewer) {
    return 'your move';
  }
  return turn === 'supplier' ? 'with the supplier' : 'with TAP';
}
